var trans = function(s, fallback) {
  if (typeof fallback === 'undefined') fallback = null;
  if (s in trans.t) {
    var ret = trans.t[s];
    // if (capitalize) ret = ret[0].toUpperCase() + ret.slice(1); // will throw exception for empty string
    return ret;
  } else {
    console.warn('Translation for message `'+s+"' is missing.");
    var ret = s;
    if (fallback !== null) ret = (fallback in trans.t) ? trans.t[fallback] : fallback;
    // if (capitalize) ret = ret[0].toUpperCase() + ret.slice(1); // will throw exception for empty string
    return ret;
  }
};

trans.setLang = function(lang) {
  if (lang in trans.lang) {
    trans.t = trans.lang[lang];
    return true;
  } else {
    var langs = [];
    for (var l in trans.lang) {
      langs.push(l);
    }
    console.warn(
      'trans.setLang("'+lang+'"): langauge is not available.'+
      ' Available languages: '+langs.join(', ')
    );
    return false;
  }
};

trans.trySetUserDefault = function() {
  if (window.navigator.language.substring(0, 2) in trans.lang) trans.setLang(window.navigator.language.substring(0, 2));
  else trans.setLang('en');
}

trans.lang = {
  en: {
    'btn:cancel': 'Cancel',
    'btn:clear_config': 'Clear app data',
    'btn:delete': 'Delete',
    'btn:initialize': 'Initialize',
    'btn:login': 'Arrival',
    'btn:log': 'Note',
    'btn:Logout': 'Departure',
    'btn:submit': 'Submit',
    'confirm:clear_config': 'Clearing app data will remove your authentication information, the app will need to be initialized again with a new initialization code. Are you sure?',
    'confirm:geoerr_continue': 'Unable to access your location. Do you want to continue anyway?',
    'err:not_an_init_code': "This doesn't look like an init code. Did you mistype it?",
    'err:sync:0': 'Failed to reach server',
    'err:sync:4': 'Request denied by server',
    'err:sync:5': 'Server error',
    ':geo:lat': 'latitude',
    ':geo:long': 'longitude',
    ':geo:show': 'show on map',
    'info:clear_config': 'If there is an authentication issue, access from your app was most likely disabled by company admin. If that is the case and you want to keep using the app: 1) admin needs to re-enable iOS/PWA access for your account, 2) you clear the app data here, 3) initialize the app with new initialization code',
    'info:initialize': 'Enter the 12-character code, not your website password or an employee QR code. If it has expired, ask your company administrator for a new one.',
    'label:cfg:location': 'Enable geolocation',
    'label:init_code': 'Initialization code',
    'label:last_sync': 'Last synchronization',
    ':login': 'Arrival',
    ':log': 'Log',
    ':Logout': 'Departure',
    'nav:close': '✖',
    'nav:refresh': 'Refresh',
    'tip:automatic': 'Is automatic',
    'tip:location': 'Contains location',
    'tip:login': 'Arrival',
    'tip:log': 'Log',
    'tip:Logout': 'Departure',
    'tip:modified': 'Is modified',
    'title:clear_config': 'Clear app data',
    'title:initialize_app': 'Initialize app',
    'title:new:login': 'New arrival',
    'title:new:log': 'New log',
    'title:new:Logout': 'New departure',
    'title:sync': 'Synchronization',
    'warning:authentication': 'Issue with authentication',
    'info:install': 'In order to use the app, you need to install it and launch it in a separate window.[br]Below are instructions for your current browser.',
    'info:install:desktop:chrome': '1) Click the [i]Install[/i] button (pictured below), or go to [i]Menu[/i] > [i]Install Frekr.me[/i] and confirm the installation[br]2) The app is now installed. There should be a launcher on your desktop, you can also find it on address [i]chrome://apps[/i][br]3) Launch the app. If you still see this, refresh the page',
    'info:install:android:chrome': '1) Go to [i]Menu[/i] > [i]Add to home screen[/i], and confirm installation[br]2) The app will be installed (this can take a short while), you can find it on your home screen or in your apps[br]3) Launch and use the app',
    'info:install:android:ff': '1) Click on the [i]install[/i] button on the address bar (as seen in video below) and confirm installation[br]2) The app will be installed (this can take a short while), you can find it on your home screen or in your apps[br]3) Launch and use the app',
    'info:install:ios:browser_unknown': '1) Open this page in the [b]Safari[/b] browser[br]2) Tap on the [i]share[/i] button > [i]Add to desktop[/i] > [i]Add[/i][br]3) Launch the app',
    'info:install:unavailable': 'We don\'t have installation instrunctions for your browser/platform combination. Either the platform doesn\'t support installing PWAs (Progressive Web App) or we just forgot to include the instrunctions. You can try look up "How to install progressive web app on [i]browser platform[/i]"',
    'placeholder:init_code': 'your init code',
  },
  cs: {
    'btn:cancel': 'Zrušit',
    'btn:clear_config': 'Odstranit data aplikace',
    'btn:delete': 'Odstranit',
    'btn:initialize': 'Inicializovat',
    'btn:login': 'Příchod',
    'btn:log': 'Záznam',
    'btn:Logout': 'Odchod',
    'btn:submit': 'Odeslat',
    'confirm:clear_config': 'Tímto odstraníte i autentizační údaje, aplikace bude muset být znovu inicializována novým inicializačním kódem. Chcete pokračovat?',
    'confirm:geoerr_continue': 'Nelze získat vaši polohu. Chcete i přesto pokračovat?',
    'err:not_an_init_code': "Toto nevypadá jako inicializační kód. Nejde o překlep?",
    'err:sync:0': 'Server je nedostupný',
    'err:sync:4': 'Požadavek byl serverem zamítnut',
    'err:sync:5': 'Chyba serveru',
    ':geo:lat': 'šířka',
    ':geo:long': 'délka',
    ':geo:show': 'zobrazit na mapě',
    'info:clear_config': 'Pokud aplikace hlásí problém s autentizací, přístup z aplikace byl pravděpodobně zakázán vaším administrátorem. Aby jste mohli znovu aplikaci používat: 1) váš administrátor bude muset povolit iOS/PWA ve vašem účtu, 2) budete zde muset zrušit nastavení a 3) inicialiovat aplikaci novým inicializačním kódem',
    'info:initialize': 'Zadejte 12 znaků kódu, nikoli heslo na web nebo QR kód zaměstnance. Pokud kód vypršel, požádejte správce vaší firmy o nový.',
    'label:cfg:location': 'Používat GPS',
    'label:init_code': 'Inicializační kód',
    'label:last_sync': 'Poslední synchronizace',
    ':login': 'Příchod',
    ':Logout': 'Odchod',
    ':log': 'Záznam',
    'nav:close': '✖',
    'nav:refresh': 'Obnovit',
    'tip:automatic': 'Událost je automatická',
    'tip:location': 'Obsahuje umístění',
    'tip:login': 'Příchod',
    'tip:Logout': 'Odchod',
    'tip:log': 'Záznam',
    'tip:modified': 'Událost je upravená',
    'title:clear_config': 'Odstranit data aplikace',
    'title:initialize_app': 'Inicializujte aplikaci',
    'title:new:login': 'Nový příchod',
    'title:new:log': 'Nový záznam',
    'title:new:Logout': 'Nový odchod',
    'title:sync': 'Synchronizace',
    'warning:authentication': 'Problém s autentizací',
    'info:install': 'Aby bylo možné aplikaci používat, musíte ji nejprve nainstalovat a pustit ve vlastním okně.[br]Níže najdete instrukce pro váš prohlížeč',
    'info:install:android:chrome': '1) Jděte do [i]Menu[/i] > [i]Přidat na plochu[/i], a potvrďte instalaci[br]2) Aplikace bude nainstalována (toto může chvilku trvat), spouštěč najdete na domovské stránce nebo v [i]aplikacích[/i][br]3) Aplikaci můžete spustit a používat',
    'info:install:android:ff': '1) Klikněte na tlačítko pro instalaci (vis video níže) a potvrďte instalaci.[br]2) Aplikace bude nainstalována (toto může chvilku trvat), spouštěč najdete na domovské stránce nebo v [i]aplikacích[/i][br]3) Aplikaci můžete spustit a používat',
    'info:install:desktop:chrome': '1) Klikněte na tlačítko pro instalaci (vis obrázek níže), nebo jděte do [i]Menu[/i] > [i]Nainstalovat Frekr.me[/i] a potvrďte instalaci[br]2) Aplikace je nyní nainstalována. Měli byste mít spouštěč na ploše, můžete ji také nelézt na adrese [i]chrome://apps[/i][br]3) Spusťte aplikaci. Pokud toto stále vidíte, obnovte stránku',
    'info:install:ios:browser_unknown': '1) Otevřte tuto stránku v prohlížeči [b]Safari[/b][br]2) Zmáčkněte tlačítko [i]sdílet[/i] > [i]Přidat na plochu[/i] > [i]Přidat[/i][br]3) Spusťte aplikaci',
    'info:install:unavailable': 'Pro váš prohlížeč/operační systém nemáme návod na instalaci. Vaše platforma nepodporuje instalaci PWA (Progresivní Webová Aplikace), nebo jsme na ni zapoměli. Můžete zkusit vyhledat "Jak nainstalovat progresivní webovou aplikaci na [i]váš prohlížeč operační systém[/i]"',
    'placeholder:init_code': 'xxxx xxxx xxxx',
  }
};

Object.assign(trans.lang.en, {
  'title:settings': 'Settings',
  'help:title': 'Frekr on your phone',
  'help:more': 'Installation and troubleshooting guide',
  'help:url': '/bundles/cestpraciapp/pwa-guide-en.html',
  'info:personal': 'Your personal attendance app. Record your own arrivals, departures and notes. Shared terminals and QR/NFC attendance points require the Android app.',
  'info:code_source': 'Your company administrator creates your code on Frekr: Users > your name > Apps and attendance entry > iOS/PWA > Create. You do not need a website password to activate this app.',
  'info:install': 'Add this page (frekr.me/m/) to your Home Screen, then open the new Frekr icon. Adding the main Frekr website will not install this attendance app.',
  'info:install:ios:browser_unknown': 'Recommended: open frekr.me/m/ in Safari. Open Share (under … in the newer layout), expand View More if needed, and choose Add to Home Screen. Enable Open as Web App if shown, and tap Add. Open the Frekr icon on your Home Screen and enter your code. If Add to Home Screen is missing, look under Edit Actions in the Share menu.',
  'info:install:desktop:chrome': 'Open the browser menu and look for Install Frekr.me or Install page as app. Confirm and launch the installed app. Menu names depend on the browser version.',
  'info:install:android:chrome': 'Open the browser menu, choose Add to Home screen or Install app, and confirm. Launch Frekr from its new icon and enter your code.',
  'info:install:android:ff': 'Open the browser menu and look for Install or Add to Home screen. Confirm, then open Frekr from its new icon.',
  'info:install:unavailable': 'Look for Install app or Add to Home screen in your browser menu. On iPhone or iPad, use Safari for the instructions above. Open the full guide for help.',
  'placeholder:comment': 'Optional note',
  'btn:refresh': 'Refresh events',
  'info:online': 'New attendance requires an internet connection. The time below is the last successful download of your events.',
  'info:empty': 'No events in the current list. Use Arrival or Departure to record attendance.',
  'info:accepted': 'The server accepted your submission for processing. Refresh the event list to check it. Do not submit it again.',
  'err:submit': 'We could not confirm your submission. It may have reached the server. Check your events before trying again. This app does not queue attendance offline.',
  'err:init': 'Activation was refused. Ask your company administrator to check iOS/PWA access and generate a new code if needed.',
  'err:sync:0': 'Unable to reach the server. Check your internet connection and try refreshing.',
  'info:clear_config': 'Only reset after checking with your company administrator. You will need a new initialization code. Attendance already stored on the server is not deleted.',
});
Object.assign(trans.lang.cs, {
  'title:settings': 'Nastavení',
  'help:title': 'Frekr v telefonu',
  'help:more': 'Návod k instalaci a řešení problémů',
  'help:url': '/bundles/cestpraciapp/pwa-guide-cs.html',
  'info:personal': 'Vaše osobní docházková aplikace. Zadávejte vlastní příchody, odchody a záznamy. Sdílené terminály a QR/NFC přístupové body vyžadují aplikaci pro Android.',
  'info:code_source': 'Kód vytvoří správce vaší firmy na webu Frekr: Uživatelé > vaše jméno > Aplikace a zadávání docházky > iOS/PWA > Vytvořit. K aktivaci nepotřebujete heslo na web.',
  'info:install': 'Přidejte si tuto stránku (frekr.me/m/) na plochu a potom otevřete novou ikonu Frekr. Uložením hlavního webu Frekr tuto docházkovou aplikaci nenainstalujete.',
  'info:install:ios:browser_unknown': 'Doporučený postup: otevřete frekr.me/m/ v Safari. Otevřete Sdílet (v novém rozložení pod …), případně rozbalte Zobrazit více (View More), a zvolte Přidat na plochu. Zapněte Otevřít jako webovou aplikaci, pokud tuto volbu vidíte, a klepněte na Přidat. Spusťte ikonu Frekr z plochy a zadejte kód. Pokud Přidat na plochu chybí, podívejte se na Upravit akce v nabídce Sdílet.',
  'info:install:desktop:chrome': 'V nabídce prohlížeče najděte Nainstalovat Frekr.me nebo Nainstalovat stránku jako aplikaci. Potvrďte a spusťte nainstalovanou aplikaci. Názvy nabídek se liší podle verze prohlížeče.',
  'info:install:android:chrome': 'V nabídce prohlížeče zvolte Přidat na plochu nebo Nainstalovat aplikaci a potvrďte. Spusťte novou ikonu Frekr a zadejte kód.',
  'info:install:android:ff': 'V nabídce prohlížeče najděte Nainstalovat nebo Přidat na plochu. Potvrďte a spusťte Frekr z nové ikony.',
  'info:install:unavailable': 'V nabídce prohlížeče hledejte Nainstalovat aplikaci nebo Přidat na plochu. Na iPhonu či iPadu doporučujeme Safari. Další postup najdete v úplném návodu.',
  'placeholder:comment': 'Nepovinná poznámka',
  'btn:refresh': 'Obnovit události',
  'info:online': 'Pro zadání docházky potřebujete internet. Čas níže označuje poslední úspěšné načtení událostí.',
  'info:empty': 'V aktuálním seznamu nejsou žádné události. Docházku zadáte tlačítkem Příchod nebo Odchod.',
  'info:accepted': 'Server přijal požadavek ke zpracování. Ověřte jej obnovením seznamu událostí. Nezadávejte jej znovu.',
  'err:submit': 'Nepodařilo se potvrdit odeslání. Požadavek mohl dorazit na server. Před opakováním zkontrolujte své události. Tato aplikace neukládá docházku do offline fronty.',
  'err:init': 'Aktivace byla zamítnuta. Požádejte správce vaší firmy o kontrolu přístupu iOS/PWA a případně o nový kód.',
  'err:sync:0': 'Server není dostupný. Ověřte připojení k internetu a zkuste obnovit události.',
  'info:clear_config': 'Data aplikace odstraňujte až po domluvě se správcem vaší firmy. Budete potřebovat nový inicializační kód. Docházka již uložená na serveru se nesmaže.',
});

trans.setLang('en');
trans.lang.sk = trans.lang.cs;

export default trans;
